<template>
  <div class="register" :style="backgroundDiv">
    <blockquote v-if="!register">
      <a-col span="24" class="loginTitle">
        <img src="../assets/logo-h5.png" />
        <span>翻红馆</span>
      </a-col>
      <a-col span="24" class="registerTip" v-if="code">
        <img :src="imgUrl" />
        <span
          ><span>{{ userName }}</span> 邀请您加入翻红馆，一起口播赚钱</span
        >
      </a-col>
      <a-form
        id="components-form-demo-normal-login"
        :form="form"
        class="login-form"
        @submit="handleSubmit"
      >
        <a-form-item>
          <a-input
            class="first-child"
            autocomplete="off"
            v-decorator="[
              'userName',
              {
                rules: [{ required: false, message: '请输入用户名!' }],
              },
            ]"
            placeholder="输入手机号"
            :maxLength="phoneLength"
          >
          </a-input>
        </a-form-item>
        <a-form-item>
          <a-input
            class="last-child"
            autocomplete="off"
            v-decorator="[
              'password',
              {
                rules: [{ required: false, message: '请输入密码!' }],
              },
            ]"
            placeholder="输入验证码"
            :maxLength="codelength"
          >
          </a-input>
          <span v-if="time > 0">{{ time }}s后再次获取</span>
          <span @click="getCode" v-if="time == 0">获取验证码</span>
        </a-form-item>
        <a-form-item v-if="code">
          <a-input
            class="end-child"
            autocomplete="off"
            placeholder="邀请码"
            v-decorator="[
              'code',
              {
                rules: [{ required: false }],
              },
            ]"
            :disabled="true"
          >
          </a-input>
          <span class="inviteCode">{{ code }}</span>
        </a-form-item>
        <a-form-item v-else>
          <a-input
            class="end-child"
            autocomplete="off"
            v-decorator="[
              'inviteCode',
              {
                rules: [{ required: false, message: '请输入邀请码!' }],
              },
            ]"
            placeholder="输入邀请码"
            :maxLength="codelength"
          >
          </a-input>
        </a-form-item>
        <a-form-item class="button">
          <a-button type="primary" html-type="submit" class="login-form-button">
            快速注册
          </a-button>
        </a-form-item>
        <router-link tag="a" to="/loginApp" class="gotoLogin"
          >已有账号，点此登录</router-link
        >
      </a-form>
    </blockquote>
    <blockquote v-if="register">
      <a-col span="24" class="successTitle">
        <img src="../assets/success-h5.png" />
        <span>注册成功</span>
      </a-col>
      <a-button
        type="primary"
        html-type="submit"
        class="login-form-button download"
        @click="download('Android')"
      >
        Android版本下载
      </a-button>
      <a-button
        type="primary"
        html-type="submit"
        class="login-form-button download"
        @click="download('iOS')"
      >
        iOS版本下载
      </a-button>
    </blockquote>
    <!-- <div class="tip">
      <span>有疑问，请咨询客服</span>
      <img src="../assets/arrow-h5.png" />
    </div> -->
    <div class="showToast" v-if="showToast">
      <div class="showToast_con">{{ showToast }}</div>
    </div>

    <div class="success_tip" v-if="success_tip" @click="closeTip">
      <img src="../assets/register-tip.png" />
    </div>
    <div class="download_tip" v-if="download_tip">
      <div class="download_con">
        <div class="title">提示信息</div>
        <div class="content">
          iOS版本正在审核中，您可以在网页登录后，邀请好友加入
        </div>
        <div class="button">
          <a @click="hideTip">取消</a>
          <router-link tag="a" to="/loginApp" class="gotoLogin"
            >去登录</router-link
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import 'lib-flexible'

import { resetRem } from "@/assets/rem.js";
export default {
  data() {
    return {
      spinning: true,
      success_tip: false,
      form: this.$form.createForm(this, { name: "normal_login" }),
      time: 0,
      showToast: "",
      register:this.$route.query.register,
      download_tip: false,
      phoneLength: 11,
      codelength: 6,
      userName: "",
      code: this.$route.query.inviteCode,
      imgUrl: "",
      phone: "",
      url:'',
      backgroundDiv: {
        backgroundImage: "url(" + require("../assets/bg-h5.png") + ")",
        backgroundRepeat: "no-repeat",
        backgroundSize: "100% 100%",
      },
    };
  },
  created() {
    resetRem();
  },
  beforeCreate() {
    this.form = this.$form.createForm(this, { name: "normal_login" });
  },
  activated() {
    this.form.setFieldsValue({
      userName: "",
      password: "",
    });
  },
  mounted() {
    if(this.code){
      this.meInvite();
    }
    // this.appPack();
  },
  methods: {
    meInvite() {
      var that = this;
      var data = {};
      data.invite_code = that.code;
      that.axios.get("/app/user/meInvite", { params: data }).then((res) => {
        that.confirmLoading = false;
        //   that.axios.get("/Api/admin/city/edit",{params: data}).then((res)=>{
        if (that.$code(res)) {
          that.userName = res.data.data.nickname;
          that.imgUrl = res.data.data.avatar;
        }
        that.visible = false;
      });
    },
    appPack() {
      var that = this;
      that.axios.get("/app/open/appPack/release").then((res) => {
        //   that.axios.get("/Api/admin/city/edit",{params: data}).then((res)=>{
        if (that.$code(res)) {
          that.url = res.data.data.url;
        }
      });
    },
    getCode() {
      var that = this;
      that.form.validateFields((err, values) => {
        if (!values.userName) {
          that.showToast = "请填写手机号获取";
          setTimeout(function () {
            that.showToast = "";
          }, 2000);
        } else {
          let reg = /^1\d{10}$/;
          if (reg.test(values.userName)) {
            that.time = 60;
            var data = { mobile: values.userName };
            that.axios.post("/app/sendSms/register", data).then((res) => {
              that.phone = values.userName;
              if (res.data.code == 200) {
                that.showToast = "验证码发送成功";
                setTimeout(function () {
                  that.showToast = "";
                }, 2000);
              } else if (res.data.code == 5003) {
                that.showToast = res.data.msg;
                setTimeout(function () {
                  that.showToast = "";
                }, 2000);
                that.register = true;
                var code=that.code?that.code:''
               this.$router.push({path: that.$route.path+"?inviteCode="+code+"&register=true"});
              } else {
                that.showToast = res.data.msg;
                setTimeout(function () {
                  that.showToast = "";
                }, 2000);
                that.register = false;
                that.form.setFieldsValue({
                  password: "",
                });
              }
            });
            var timer = setInterval(function () {
              that.time = that.time - 1;
              if (that.time <= 0) {
                that.time = 0;
                clearInterval(timer);
              }
            }, 1000);
          } else {
            that.showToast = "请填写正确的手机号";
            setTimeout(function () {
              that.showToast = "";
            }, 2000);
          }
        }
      });
    },
    handleSubmit(e) {
      e.preventDefault();
      var that = this;
      that.form.validateFields((err, values) => {
        if (!values.userName || !values.password) {
          that.showToast = "请输入手机号验证码";
          setTimeout(function () {
            that.showToast = "";
          }, 2000);
          return false;
        } else {
          if (values.userName != that.phone) {
            that.showToast = "请填写正确的手机号";
            setTimeout(function () {
              that.showToast = "";
            }, 2000);
            return false;
          }
          let regCode = /^\d{6}$/;
          if (!regCode.test(values.password)) {
            that.showToast = "请填写正确的验证码";
            setTimeout(function () {
              that.showToast = "";
            }, 2000);
            return false;
          }
          if(!that.code){
             if (!regCode.test(values.inviteCode)){
              that.showToast = "请填写正确的邀请码";
              setTimeout(function () {
                that.showToast = "";
              }, 2000);
              return false;
             }
          }
          var data = {
            mobile: values.userName,
            code: values.password,
          };
          if(that.code){
            data.invite_code = that.code;
          }else{
            data.invite_code=values.inviteCode;
          }
          that.axios.post("/app/register", data).then((res) => {
            if (res.data.code == 200) {
              that.showToast = "注册成功";
              setTimeout(function () {
                that.showToast = "";
              }, 2000);
                var code=data.inviteCode
                that.register = true;
               this.$router.push({path: that.$route.path+"?inviteCode="+code+"&register=true"});
            } else {
              that.showToast = res.data.msg;
              setTimeout(function () {
                that.showToast = "";
              }, 2000);
              that.register = false;
              that.form.setFieldsValue({
                password: "",
                inviteCode: "",
              });
            }
          });
        }
        // if (!err) {
        //   }
      });
    },
    hideTip() {
      this.download_tip = false;
    },
    download(e) {
      var that = this;
      if (e == "iOS") {
        // that.download_tip = true;
        that.url="https://apps.apple.com/cn/app/%E7%BF%BB%E7%BA%A2%E9%A6%86-%E4%B8%80%E6%AC%BE%E9%9D%A0%E7%9F%AD%E8%A7%86%E9%A2%91%E8%B5%9A%E9%92%B1%E7%9A%84app/id1552911522"
      } else {
        that.url="https://a.app.qq.com/o/simple.jsp?pkgname=com.xingke.fanhongguan"
      }
      window.location.href=that.url
      // if (e == "iOS") {
      //   that.download_tip = true;
      // } else {
      //   // const isWeiXin = function(){
      //   //window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
      //   var ua = window.navigator.userAgent.toLowerCase();
      //   //通过正则表达式匹配ua中是否含有MicroMessenger字符串
      //   if (ua.match(/MicroMessenger/i) == "micromessenger") {
      //     this.success_tip = true;
      //   } else {
      //     this.success_tip = false;
      //     // var src = "http://d.58auv.com/fanhong/0.8.apk";
      //     // var form = document.createElement("form");
      //     // form.action = src;
      //     // document.getElementsByTagName("body")[0].appendChild(form);
      //     // form.submit();
      //     //  let url = window.URL.createObjectURL(new Blob(["http://d.58auv.com/fanhong/0.8.apk"]))
      //     let link = document.createElement('a')
      //     link.style.display = 'none'
      //     link.href = this.url
      //     // link.setAttribute('download', "fanhong0.8.apk")// 文件名
      //     document.body.appendChild(link)
      //     link.click()
      //     document.body.removeChild(link) // 下载完成移除元素
      //     // window.URL.revokeObjectURL(url) // 释放掉blob对象
          
      //   }
      //   // }
      // }
    },
    closeTip() {
      this.success_tip = false;
    },
  },
};
</script>
<style scoped>
.register {
  width: 10rem;
  margin: 0 auto;
  height: 100vh;
  background: url("../assets/bg-h5.png") no-repeat 50% 50%;
  background-size: cover;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}
.register .ant-form {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  margin-top: 0.64rem;
}
.register .loginTitle {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  margin-top: -2.2rem;
  margin-bottom: 0.64rem;
}
.register .loginTitle img {
  width: 2.56rem;
  margin-bottom: 0.21333rem;
}
.register .loginTitle span {
  font-family: PingFang-SC-Heavy;
  font-size: 0.64rem;
  line-height: 0.88rem;
  color: #ddb383;
  letter-spacing: 0;
  text-align: center;
}
.register .registerTip {
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  margin: 0;
}
.register .registerTip img {
  width: 0.4267rem;
  height: 0.4267rem;
  margin-right: 0.16rem;
  border-radius: 50%;
}
.register .registerTip span {
  font-family: PingFangSC-Regular;
  font-size: 0.32rem;
  color: #ffffff;
  letter-spacing: 0;
}
.register .registerTip span span {
  color: #ddb383;
}
.register .ant-form-item {
  margin-bottom: 0;
  height: 1.333rem;
  width: 7.6267rem;
  /* border: 0.0267rem solid #FFFFFF; */
}
.register .ant-form-item:last-child {
  height: auto;
  margin-top: 0.64rem;
}
.register .ant-form-item.button {
  margin-top: 0.64rem;
  margin-bottom: 0.64rem;
}
.register .button .gotoLogin {
  margin-top: 0;
}
.register .ant-form-item input {
  padding: 0.4267rem;
  height: 1.333rem;
  width: 7.6267rem;
  border-radius: 0;
  border: 0.0267rem solid #3b3b3b;
  background: #272727;
  box-sizing: border-box;
  font-family: PingFangSC-Regular;
  font-size: 0.3733rem;
  color: #fff;
  background: transparent !important;
  position: relative;
}
.register .ant-form-item span {
  display: block;
  height: 1.333rem;
  line-height: 1.333rem;
}
.register .ant-form-item span > span {
  position: absolute;
  top: 0;
  right: 0;
  height: 1.333rem;
  line-height: 1.333rem;
  padding-right: 0.4267rem;
  font-family: PingFangSC-Regular;
  font-size: 0.3733rem;
  color: #ddb383;
  letter-spacing: 0;
}
.register .ant-form-item span.inviteCode {
  position: absolute;
  top: 0;
  right: 0;
  height: 1.333rem;
  line-height: 1.333rem;
  padding-right: 0.4267rem;
  font-family: PingFangSC-Regular;
  font-size: 0.3733rem;
  color: #fff;
  letter-spacing: 0;
}
.register .ant-form-item input:focus,
.register .ant-input:hover,
.register .ant-form-item input:active {
  border: 0.0267rem solid #3b3b3b;
  box-shadow: none;
}
.register .ant-form-item input:-webkit-autofill {
  -webkit-box-shadow: 0 0 0px 1000px transparent;
}
.register .ant-form-item input.first-child {
  border-top-right-radius: 0.1067rem;
  border-top-left-radius: 0.1067rem;
  border-bottom: 0;
}
/deep/.ant-form-item-children {
  display: block;
  height: 100%;
}
.register .ant-form-item input.end-child {
  border-bottom-right-radius: 0.1067rem;
  border-bottom-left-radius: 0.1067rem;
  border-top: 0;
  position: relative;
}
.register .ant-form-item input::-webkit-input-placeholder {
  opacity: 0.3;
  font-family: PingFangSC-Regular;
  font-size: 0.3733rem;
  color: #ffffff;
  font-weight: normal;
}
.register .ant-btn-primary {
  display: block;
  width: 7.6267rem;
  height: 1.3333rem;
  background-image: linear-gradient(-45deg, #ddb383 0%, #b17b55 100%);
  border-radius: 0.1067rem;
  border: 0;
  font-family: PingFangSC-Regular;
  font-size: 0.4267rem;
  color: #ffffff;
  letter-spacing: 0;
  text-align: center;
  margin: 0 auto;
}
.register .ant-btn-primary:hover,
.register .ant-btn-primary:focus,
.register .ant-btn-primary:active,
.register .ant-btn-primary.active {
  background-image: linear-gradient(-45deg, #ddb383 0%, #b17b55 100%);
}
/* .register .tip {
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  font-family: PingFangSC-Regular;
  font-size: 0.3733rem;
  color: #ddb383;
  letter-spacing: 0;
  text-align: center;
  margin-top: 0.64rem;
}
.register .tip img {
  width: 0.5333rem;
} */
.register .showToast {
  width: 10rem;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  position: fixed;
}
.register .showToast_con {
  height: 1.333rem;
  line-height: 1.333rem;
  background: #4c4c4c;
  border-radius: 0.667rem;
  padding: 0 1.28rem;
  font-family: PingFang-SC-Regular;
  font-size: 0.4267rem;
  color: #ffffff;
  letter-spacing: 0;
}
.register .successTitle img {
  width: 1.7067rem;
  margin-bottom: 0.42667rem;
}
.register .successTitle {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  font-family: PingFang-SC-Heavy;
  font-size: 0.64rem;
  line-height: 0.88rem;
  color: #ddb383;
  letter-spacing: 0;
  text-align: center;
  margin-bottom: 0.8533rem;
  margin-top: -2.2rem;
}
.register blockquote {
  margin: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.success_tip {
  position: fixed;
  top: 0;
  left: 0;
  width: 10rem;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
}
.success_tip img {
  width: 10rem;
}
.download {
  margin-bottom: 0.64rem !important;
}
.gotoLogin {
  display: block;
  width: 7.6267rem;
  height: 1.3333rem;
  line-height: 1.3333rem;
  background: rgba(221, 179, 131, 0.1);
  border-radius: 0.1067rem;
  border: 0;
  font-family: PingFangSC-Regular;
  font-size: 0.4267rem;
  letter-spacing: 0;
  text-align: center;
  margin: 0 auto;
  color: #ddb383;
  margin-top: -0.32rem;
}
.download_tip {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.6);
}
.download_con {
  width: 8.72rem;
  height: 5.4933rem;
  border-radius: 0.32rem;
  background: #fff;
  padding: 0.533rem 0.8rem 0.8rem;
}
.download_tip .title {
  font-family: PingFangSC-Regular;
  font-size: 0.5333rem;
  line-height: 0.7467rem;
  color: #000000;
  letter-spacing: 0;
  text-align: center;
  margin-bottom: 0.32rem;
}
.download_tip .content {
  font-family: PingFangSC-Regular;
  font-size: 0.3733rem;
  color: #666666;
  letter-spacing: 0;
  line-height: 0.68rem;
}
.download_tip .button {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  margin-top: 0.48rem;
}
.download_tip .button * {
  border: 1px solid #979797;
  border-radius: 0.107rem;
  width: 3.0933rem;
  height: 1.333rem;
  line-height: 1.333rem;
  text-align: center;
  font-size: 0.4267rem;
  color: #333333;
  box-sizing: border-box;
}
.download_tip .button a:last-child {
  color: #fff;
  background-image: linear-gradient(-45deg, #ddb383 0%, #b17b55 100%);
  border: 0;
}
</style>